<template>
  <div class="stacked-wrapper">
    <div class="contentSection">
      <div class="col-md-12 text-center">
        <div class="image-upload" v-if="!image">
          <label for="file-input">
            <img v-if="offer.imageUrl" id="img" class="pointer" :src="offer.imageUrl">
            <img v-else id="img" class="pointer" src="@/assets/imgs/img-placeholder.png">
          </label>
          <input type="file" id="file-input" @change="$emit('handlefile', $event)" accept="image/*">
        </div>
        <div class="image-preview" v-else>
          <img :src="image" alt>
        </div>
        <h2>
          <input
            class="hidden w-100"
            placeholder="Headline"
            v-model="offer.headline"
            type="text"
            required
          >
        </h2>
        <p>
          <input
            class="hidden w-100"
            placeholder="Offer text"
            v-model="offer.tagline"
            type="text"
            required
          >
        </p>
      </div>
      <div class="row">
        <div class="col-md-6 text-right">
          <input
            style
            v-model="offer.linkOutButtonText"
            class="greenBtn hidden"
            type="text"
            required
          >
        </div>
        <div class="col-md-6 text-left">
          <input style v-model="offer.nextButtonText" class="greyBtn hidden" type="text" required>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center mt-3 ">
          <textarea rows="3"   type="text " class="hidden disclaimer w-75" placeholder="Disclaimer Text" v-model="offer.disclaimer"></textarea>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['offer', 'image']
}
</script>
<style lang="scss" scoped>
.stacked-wrapper {
  .tokenBtn {
    padding: 8px 16px;
    line-height: 18px;
    font-size: 16px;
  }
  .hidden-button {
    background-color: $container-bg;
    color: $mainColor;
    &:hover {
      background-color: $container-bg;
    }
  }
  .fa-link:before {
    margin: 10px;
  }
  .image-upload,
  .placeholder {
    input {
      display: none;
    }
  }
  .hidden {
    text-align: center;
    border: none;
    outline: none;
    // color: #666666;
    h2 {
      font-size: 26px;
      font-weight: 200;
    }
  }
  .blend {
    background-color: #f2f2f2;
  }
  .disclaimer {
    resize: none;
    font-style: italic;
    font-size:13px;
    color:#666;
    line-height: 1.75rem;
    margin: 10px 0;
  }
}
</style>
